import { useEffect, useState } from 'react'
import axios from 'axios'
import { Wallpaper } from '../../components/Wallpaper'
import { QRCodeSVG } from 'qrcode.react'
import {
    Button
} from '../DocumentsInbox/styles'
import * as S from './styles'
import * as G from '../../theme/global-styles'
import { ThemedButton } from '../../components/ThemedButton'
import ClientLogo from '../../components/ClientLogo'
import PoweredbByQITech from '../../components/PoweredByQITech'
import { Box } from '@mui/material';
import Logo from '../../components/Logo';
import { Footer } from '../../components/Footer';
import { CollectImageTitle } from '../PersonalDocument/styles'
import { LoadingPage } from '../LoadingPage'

export const DesktopFaceRecognition = (props) => {

    const { clientThemeSettings, signData, loading, setSignerStep, setAlreadySigned, setCanceled, setExpired, appTheme } = props

    const [qrCodeJwtUrl, setQrCodeJwtUrl] = useState()
    const [internalLoading, setInternalLoading] = useState(true)
    const handleReturnDocumentDisplay = async () => {
        setSignerStep("document_display")
    };

    useEffect(() => {

        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }

        if (signData.signer_data?.callback_url) {
            const interval = setInterval(() => {
                axios.get('/signer', config)
                    .then((response) => {
                        setQrCodeJwtUrl(response.data.signature_url)
                        if (["signed", "sending_sign_receipt", "receipt_sent", "analyzing", "analyzed", "completed"].includes(response.data.status)) {
                            if (response.data.status !== "signed") {
                                setAlreadySigned(true)
                            }
                            setSignerStep("signed")
                        } else if (response.data.status === "canceled") {
                            setCanceled(true)
                        } else if (response.data.status === "expired") {
                            setExpired(true)
                        }
                    }).catch((error) => { })
            }, 4000);
            setInternalLoading(false)
            const timeout = setTimeout(() => {
                clearInterval(interval);
            }, 1200000); //20 min - max pooling timeout

            return () => {
                clearInterval(interval);
                clearTimeout(timeout);
            }
        } else {
            axios.get('/signer', config)
                .then((response) => {
                    setQrCodeJwtUrl(response.data.signature_url)
                    setInternalLoading(false)
                    if (["signed", "sending_sign_receipt", "receipt_sent", "analyzing", "analyzed", "completed"].includes(response.data.status)) {
                        if (response.data.status !== "signed") {
                            setAlreadySigned(true)
                        }
                        setSignerStep("signed")
                    } else if (response.data.status === "canceled") {
                        setCanceled(true)
                    } else if (response.data.status === "expired") {
                        setExpired(true)
                    }
                })
                .catch((error) => {
                    if (error.response?.status === 401) {
                        setSignerStep("login")
                    }
                }).finally(() => setInternalLoading(false))
        }
    }, [signData.signer_data?.callback_url, signData.signer_token, setAlreadySigned, setSignerStep, setCanceled, setExpired])

    if (internalLoading || !qrCodeJwtUrl) {
        return (
            <LoadingPage />
        )
    }

    if (appTheme === 'release') {
        return (
            <G.Container>
                <ClientLogo clientThemeSettings={clientThemeSettings} size="small" />
                <G.Title>Prova de vida</G.Title>
                <G.Description>Agora, precisamos confirmar sua identidade. Escaneie o QR Code abaixo com a câmera do seu celular para continuar.</G.Description>
                <S.QRCodeContainer>
                    <QRCodeSVG value={qrCodeJwtUrl} width={'70%'} height={'70%'} />
                </S.QRCodeContainer>
                <S.Footer>
                    {signData.signature_settings?.document_display_before_face_recognition && (
                        <ThemedButton
                            onClick={() => {
                                handleReturnDocumentDisplay()
                            }}
                            type='primary'
                            clientThemeSettings={clientThemeSettings}
                            loading={loading}
                            disabled={internalLoading}
                        >
                            Ler contrato novamente
                        </ThemedButton>
                    )
                    }
                </S.Footer>
                <PoweredbByQITech />
            </G.Container>
        );
    }

    return (
        <Wallpaper
            backgroundColor={clientThemeSettings["background_color"]}
            style={{ padding: '10px' }}
        >
            <div className="base-container base-container-width base-container-padding" style={{ backgroundColor: "rgb(245, 245, 242)" }}>
                <Logo imageSource={clientThemeSettings.logo_url} />
                <Box>
                    <CollectImageTitle>
                        Agora precisamos realizar a prova de vida. Escaneie o QR Code abaixo para continuar a jornada pelo seu dispositivo móvel.
                    </CollectImageTitle>
                    <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', height: '100%' }}>
                            <QRCodeSVG value={qrCodeJwtUrl} width={'70%'} height={'70%'} />
                        </div>
                    </div>
                    {
                        (signData.signature_settings?.document_display_before_face_recognition === true) && (
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '30px' }}>
                                <Button
                                    onClick={() => {
                                        handleReturnDocumentDisplay()
                                    }}
                                    clientThemeSettings={clientThemeSettings}
                                    loading={loading}
                                >
                                    LER DOCUMENTO NOVAMENTE
                                </Button>
                            </div>
                        )
                    }
                </Box>
                <Footer />
            </div>
        </Wallpaper>
    )
}
